import { render, staticRenderFns } from "./recordView.vue?vue&type=template&id=51c765e0&scoped=true"
import script from "./recordView.vue?vue&type=script&lang=js"
export * from "./recordView.vue?vue&type=script&lang=js"
import style0 from "./recordView.vue?vue&type=style&index=0&id=51c765e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c765e0",
  null
  
)

export default component.exports